<script>
export default {
    name: "SelectInput",
    props: {
        label: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: []
        },
        placeholder: {
            type: String,
            default: '',
        },
        modelValue: {
            default() {
                return null;
            },
        },
        selectPropertyName: {
            type: String,
            default() {
                return 'value';
            },
        },
        showPropertyName: {
            type: String,
            default() {
                return 'name';
            },
        }
    },
    data() {
        return {
            isFocused: false
        }
    },
    methods: {
        handleFocus: _.debounce(function (value) {
            this.isFocused = value;
        }, 500),

        handleInput: _.debounce(function (value) {
            this.$emit('input', value);
        }, 200),

        selectItem(option) {
            console.log('Selecting item:', option);
            this.$emit('update:modelValue', option);
            this.$emit('selected', option);
        }
    }
}
</script>

<template>
    <div class="select-input">
        <label
            v-if="label"
            class="select-input__label"
        >
            {{ label }}
        </label>

        <div class="relative">
            <div class="select-input__form">
                <input
                    type="text"
                    v-model="modelValue[showPropertyName]"
                    :placeholder="placeholder"
                    @input="handleInput($event.target.value)"
                    @focus="handleFocus(true)"
                    @blur="handleFocus(false)"
                />
            </div>

            <div
                v-if="isFocused"
                class="select-input__menu"
            >
                <div
                    v-for="option in options"
                    class="select-input__menu-item"
                    @click="selectItem(option)"
                >
                    {{ option[showPropertyName] }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    $bgColor: #f1f4f9;
    $borderColor: #e1e8f0;
    $textColor: #000000;

    .select-input {
        position: relative;

        &__label {
            font-size: 14px;
            color: #000000;
            margin-bottom: .5rem;
            display: inline-block;
        }

        &__form {
            display: flex;
            height: 50px;
            width: 100%;
            border: 2px solid $borderColor;
            border-radius: .5rem;
            background: $bgColor;
            padding: 0 1rem;

            input {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                font-size: 1rem;
                outline-color: #93c5fd;
                color: $textColor;
                background: $bgColor;

                &:focus {
                    border: none;
                    outline: none;
                }
            }
        }

        &__menu {
            width: 100%;
            min-height: 56px;
            background: $bgColor;
            border: 2px solid $borderColor;
            border-bottom-left-radius: .5rem;
            border-bottom-right-radius: .5rem;
            border-top: none;
            position: absolute;
            z-index: 100;
            top: 42px;
            padding: .5rem 0;

            &-item {
                cursor: pointer;
                padding: .5rem 1rem;

                &:hover {
                    background: #93c5fd;
                    color: $textColor;
                }
            }
        }
    }
</style>